import styled from "@emotion/styled";
import {colors, fontSize, sizes} from "patient-ping-remedy/packages/theme";
import {DisplaySmallTypography} from "patient-ping-remedy/packages/typography";

export const AppointmentCardWrapper = styled.div`
    border: 1px solid ${colors.gray2};
    border-radius: ${sizes.xSmall};
    margin: ${sizes.medium} 0 ;
    padding: ${sizes.small};
    cursor: pointer;
    display: flex;
    
    &:hover {
      border: 2px solid ${colors.primary1};
    }
`;

export const TypeTitle = styled(DisplaySmallTypography)`
  color: ${colors.primary1};
`;

export const AppointmentContentWrapper = styled('div')`
    display: flex;
    flex-direction: row;
    width: 100%;
`;

export const AppointmentContentSection = styled('div')<{width: string}>`
    width: ${({width}) => width};
`;

export const AppointmentContentSectionTitle = styled('span')`
    font-weight: 600;
    font-size: ${fontSize.standard};
    margin-right: ${sizes.xSmall};
`;

export const AppointmentContentItem = styled('div')`
    padding-top: ${sizes.xSmall};
    display: flex;
`;

export const AppointmentContentTitle = styled('div')`
    padding-bottom: ${sizes.xxSmall};
`;
